import styled from 'styled-components';
import { hexToRGBa } from '../../helpers';
import { IconWrapper } from './basic';

interface IModalStyled {
	disableTransparency: boolean;
}

export const ModalStyled = styled.div<IModalStyled>`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${({ theme, disableTransparency }) => (disableTransparency ? theme.color.jumbo : hexToRGBa(theme.color.blackPearl, 0.7))};
	z-index: 1000000000;
	padding: 16px;

	a {
		margin-bottom: 8px;
	}
`;
export const LoadingModalStyled = styled.div<IModalStyled>`
	box-shadow: ${({ theme, disableTransparency }) => (disableTransparency ? 'none' : `0 1px 2px ${hexToRGBa(theme.color.blueBayoux, 0.3)}`)};
	border-radius: 2px;
	padding: 16px 12px;
	font-size: 16px;
	line-height: 16px;
	color: ${({ theme }) => theme.color.white};
	display: flex;
	flex-direction: column;
	align-items: center;

	${IconWrapper} {
		filter: invert(1);
		margin-bottom: 15px;
		width: 48px;
	}
`;
export const LoadingModalText = styled.span`
	font-size: 18px;
	white-space: pre-line;
	text-align: center;
	line-height: 30px;
`;
